<div class="max-w-[1280px] mx-auto igntr-theme bg-[--background-color]">
  <div class="p-7 space-y-5">
    <div class="flex items-start justify-between mb-4">
      <div class="flex items-start gap-2.5">
        <div
          class="w-8 h-8 rounded-lg bg-white border !border-slate-200 flex items-center justify-center !text-slate-700"
        >
          <igntr-icon name="tag"></igntr-icon>
        </div>
        <div>
          <div class="text-[14px] font-semibold !text-slate-900">
            {{ "tags" | transloco }}
          </div>
          <div class="text-[12px] !text-slate-500 mt-0.5">
            {{ "freeFormLabels" | transloco }}
          </div>
        </div>
      </div>
    </div>

    <div class="rounded-xl border !border-slate-200/70 bg-white p-3.5">
      <div class="flex flex-wrap gap-1.5">
        <div
          class="inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-[14px] font-medium border"
          *ngFor="let tag of tags; let i = index"
          [style]="
            'background: oklch(0.95 0.04 ' +
            i * 47 +
            '); color: oklch(0.4 0.15 ' +
            i * 47 +
            '); border-color: transparent'
          "
        >
          <span
            class="w-1.5 h-1.5 rounded-full"
            [style]="'background: oklch(0.38 0.1 ' + i * 47 + ')'"
          ></span>
          {{ tag.title }}
          <button
            class="opacity-60 hover:opacity-100"
            (click)="deleteConf = { id: tag.id!, name: tag.title! }"
          >
            ×
          </button>
        </div>
        <div class="flex items-center gap-1.5">
          <input
            type="text"
            placeholder="{{ 'enterTag' | transloco }}"
            [(ngModel)]="newTagText"
            class="w-[140px] inline-flex items-center gap-1 px-2 py-1 rounded-md text-[14px] border border-dashed !border-slate-300 !text-slate-500 hover:!bg-slate-50"
          />
          <button
            class="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[14px] border border-dashed !border-slate-300 !text-slate-500 hover:!bg-slate-50"
            (click)="addTag()"
          >
            <igntr-icon name="plus"></igntr-icon>
            {{ "addTag" | transloco }}
          </button>
        </div>
      </div>
    </div>
    <!-- <div class="tenant-tags-container mt-4">
      <h2>Tenant Tags</h2>

      <div class="mb-2">
        <input
          type="text"
          pInputText
          [(ngModel)]="newTagText"
          placeholder="Enter tag name"
          class="tag-input"
        />
        <button
          pButton
          type="button"
          icon="pi pi-plus"
          (click)="addTag()"
          class="ms-2"
        ></button>
      </div>

      <p-table
        #dt1
        [value]="tags"
        class="p-0"
        [globalFilterFields]="['name', 'description']"
      >
        <ng-template pTemplate="header">
          <tr>
            <th [attr.colspan]="innerWidth < 1200 ? 2 : 1">
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-search"></i>
                </p-inputgroup-addon>
                <input
                  type="text"
                  pInputText
                  (input)="onGlobalFilter(dt1, $event)"
                  placeholder="{{ 'search' | transloco }}"
                />
              </p-inputgroup>
            </th>
            <th class="d-none d-xl-table-cell"></th>
          </tr>
          <tr>
            <th pSortableColumn="title" class="col-6 col-xl-3">
              {{ "title" | transloco }} <p-sortIcon field="title"></p-sortIcon>
            </th>
            <th pSortableColumn="createdAt" class="col-5 col-xl-2">
              {{ "created" | transloco }}
              <p-sortIcon field="createdAt"></p-sortIcon>
            </th>
            <th class="col-1"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tag>
          <tr>
            <td>{{ tag.title }}</td>
            <td>{{ tag.createdAt | date: "dd-MM-yyyy" }}</td>
            <td>
              <div style="display: flex; justify-content: end">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  class="small-icon-button d-flex justify-content-center align-items-center p-0"
                  style="
                    width: 32px;
                    height: 32px;
                    font-size: 20px;
                    line-height: 1;
                  "
                >
                  <img src="assets/img/dots-vertical.svg" alt="Menu Icon" />
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editTag = tag">
                    {{ "edit" | transloco }}
                  </button>
                  <button
                    mat-menu-item
                    class="text-danger"
                    (click)="deleteConf = { id: tag.id, name: tag.title }"
                  >
                    {{ "delete" | transloco }}
                  </button>
                </mat-menu>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div> -->
  </div>
</div>
<app-confirm-delete
  id="deleteusermodal"
  *ngIf="deleteConf"
  [deleteCandidate]="deleteConf.name"
  (confirm)="handleDeleteClick(deleteConf.id); deleteConf = null"
  (cancel)="deleteConf = null"
></app-confirm-delete>

<app-edit-modal
  *ngIf="editTag"
  [editField]="editTag.title"
  (save)="updateTag($event)"
  (cancel)="editTag = undefined"
>
</app-edit-modal>
